import { render, staticRenderFns } from "./ContactEditAddresses.vue?vue&type=template&id=505aaa18&scoped=true"
import script from "./ContactEditAddresses.vue?vue&type=script&lang=ts"
export * from "./ContactEditAddresses.vue?vue&type=script&lang=ts"
import style0 from "./ContactEditAddresses.vue?vue&type=style&index=0&id=505aaa18&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505aaa18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('505aaa18')) {
      api.createRecord('505aaa18', component.options)
    } else {
      api.reload('505aaa18', component.options)
    }
    module.hot.accept("./ContactEditAddresses.vue?vue&type=template&id=505aaa18&scoped=true", function () {
      api.rerender('505aaa18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contacts/ContactEditAddresses.vue"
export default component.exports